var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "transfer" },
    [
      _c("popup", {
        staticClass: "popup",
        attrs: { opened: _vm.openData, "use-footer": true },
        on: {
          "update:opened": function($event) {
            _vm.openData = $event
          },
          cancel: _vm.popupClose
        },
        scopedSlots: _vm._u([
          {
            key: "subtitle",
            fn: function() {
              return [
                _c("h2", [
                  _vm._v(
                    _vm._s(/*이체 확인증 (당행)*/ _vm.$t("MPAY-04-01-06-A1"))
                  )
                ])
              ]
            },
            proxy: true
          },
          {
            key: "content",
            fn: function() {
              return [
                _c("div", { staticClass: "divider" }, [
                  _c("span", { staticClass: "divider-date" }, [
                    _vm._v(
                      _vm._s(/*이체 일시*/ _vm.$t("MPAY-04-01-06-A2")) +
                        " : " +
                        _vm._s(_vm.$getGlobalDateFmt(_vm.detailInfo.tranYmd))
                    )
                  ])
                ]),
                _c("div", { staticClass: "cont-tit" }, [
                  _c("h6", [
                    _vm._v(_vm._s(/*출금정보*/ _vm.$t("MPAY-04-01-06-A3")))
                  ])
                ]),
                _c("dl", { staticClass: "dlist dlist-item--type6" }, [
                  _c("dt", [
                    _vm._v(_vm._s(/*출금 계좌번호*/ _vm.$t("MPAY-04-01-06-A4")))
                  ]),
                  _c("dd", { staticClass: "right" }, [
                    _vm._v(_vm._s(_vm.detailInfo.acno))
                  ]),
                  _c("dt", [
                    _vm._v(_vm._s(/*송금인*/ _vm.$t("MPAY-04-01-06-A5")))
                  ]),
                  _c("dd", { staticClass: "right" }, [
                    _vm._v(_vm._s(_vm.detailInfo.rqstrFname))
                  ]),
                  _c("dt", [
                    _vm._v(_vm._s(/*출금 금액*/ _vm.$t("MPAY-04-01-06-A6")))
                  ]),
                  _c("dd", { staticClass: "right" }, [
                    _c("span", { staticClass: "exchange-unit" }, [
                      _vm._v(_vm._s(_vm.detailInfo.cncycd))
                    ]),
                    _c("span", { staticClass: "amount" }, [
                      _vm._v(_vm._s(_vm.$num(_vm.detailInfo.drwotzAmt)))
                    ])
                  ]),
                  _c("dt", [
                    _vm._v(_vm._s(/*적용 환율*/ _vm.$t("MPAY-04-01-06-A7")))
                  ]),
                  _c("dd", { staticClass: "right" }, [
                    _c("span", { staticClass: "amount" }, [
                      _vm._v(_vm._s(_vm.detailInfo.aplyExrt))
                    ])
                  ]),
                  _c("dt", [
                    _vm._v(_vm._s(/*수수료*/ _vm.$t("MPAY-04-01-06-A8")))
                  ]),
                  _c("dd", { staticClass: "right" }, [
                    _c("span", { staticClass: "exchange-unit" }, [
                      _vm._v(_vm._s(_vm.detailInfo.cncycd))
                    ]),
                    _c("span", { staticClass: "amount" }, [
                      _vm._v(_vm._s(_vm.$num(_vm.detailInfo.feeAmt)))
                    ])
                  ]),
                  _c("dt", [
                    _vm._v(_vm._s(/*송금 메모*/ _vm.$t("MINQ-02-02-03-13")))
                  ]),
                  _c("dd", { staticClass: "right" }, [
                    _vm._v(_vm._s(_vm.detailInfo.sumryCtnt1))
                  ])
                ]),
                _c("div", { staticClass: "cont-tit" }, [
                  _c("h6", [
                    _vm._v(_vm._s(/*입금정보*/ _vm.$t("MPAY-04-01-06-A10")))
                  ])
                ]),
                _c("dl", { staticClass: "dlist dlist-item--type6" }, [
                  _c("dt", [
                    _vm._v(
                      _vm._s(/*입금 계좌번호*/ _vm.$t("MPAY-04-01-06-A11"))
                    )
                  ]),
                  _c("dd", { staticClass: "right" }, [
                    _vm._v(_vm._s(_vm.detailInfo.cupldAcno))
                  ]),
                  _c("dt", [
                    _vm._v(_vm._s(/*입금 금액*/ _vm.$t("MPAY-04-01-06-A12")))
                  ]),
                  _c("dd", { staticClass: "right" }, [
                    _c("span", { staticClass: "exchange-unit" }, [
                      _vm._v(_vm._s(_vm.detailInfo.lnkgAcnCncycd))
                    ]),
                    _c("span", { staticClass: "amount" }, [
                      _vm._v(_vm._s(_vm.$num(_vm.detailInfo.mrvamt)))
                    ])
                  ]),
                  _c("dt", [
                    _vm._v(_vm._s(/* 수취인 */ _vm.$t("MPAY-04-01-06-A13")))
                  ]),
                  _c("dd", { staticClass: "right" }, [
                    _vm._v(_vm._s(_vm.detailInfo.draweFname))
                  ]),
                  _c("dt", [
                    _vm._v(
                      _vm._s(/*수취인 참조내용*/ _vm.$t("MPAY-04-01-06-A14"))
                    )
                  ]),
                  _c("dd", { staticClass: "right" }, [
                    _vm._v(_vm._s(_vm.detailInfo.sumryCtnt2))
                  ])
                ]),
                _c("ul", { staticClass: "ulist ulist-type--bullet" }, [
                  _c("li", [
                    _vm._v(
                      _vm._s(
                        /*위의 내용이 정상적으로 처리되었음을 확인합니다. */ _vm.$t(
                          "MPAY-04-01-06-A15"
                        )
                      )
                    )
                  ]),
                  _c("li", [
                    _vm._v(
                      _vm._s(
                        /*이체확인증은 고객 편의를 위하여 제공되는 것으로 거래의 참고용으로만 사용될 수 있습니다.*/ _vm.$t(
                          "MPAY-04-01-06-A16"
                        )
                      )
                    )
                  ])
                ]),
                _c(
                  "div",
                  { staticClass: "bank-name" },
                  [
                    _vm.siteCode == _vm.$config.SITECODE_OGHCM
                      ? [
                          _vm.operGroupCd == "VN1"
                            ? [
                                _vm._v(
                                  _vm._s(_vm.$t(_vm.siteCode + "_지점명칭"))
                                )
                              ]
                            : [_vm._v(_vm._s(_vm.$t("oghni_지점명칭")))]
                        ]
                      : [_vm._v(_vm._s(_vm.$t(_vm.siteCode + "_지점명칭")))]
                  ],
                  2
                )
              ]
            },
            proxy: true
          },
          {
            key: "footer",
            fn: function() {
              return [
                _c(
                  "button",
                  {
                    staticClass: "btn bottom positive",
                    on: {
                      click: function($event) {
                        return _vm.popupClose()
                      }
                    }
                  },
                  [_vm._v(_vm._s(/*확인*/ _vm.$t("MPAY-04-01-06-A18")))]
                )
              ]
            },
            proxy: true
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }